import { Position } from '../interfaces/general'

export default class BaseAdapter {
  protected lastKnownPosition: Position

  protected getEvent(event: any) {
    if (event.touches) {
      event = event.touches[0]
    }

    return event
  }
}
